import { sendPost } from '@/utils/request.js';

export const mySendPost = (url, data) => {
  return sendPost(url, data, false, '', 'post', '/df-gw')
    .then(res => {
      if (res && res.code === 'BFF000000') {
        return res.data;
      }

      // request里统一处理了error和toast，且没有抛出错误，导致异常进入了正常的业务逻辑，所以这里需要再次抛出异常。
      throw new Error(res);
    });
};

/**
 * 格式化城市数据
 * @param res 
 * @returns 
 */
export function transformCities(res) {
  const data = res;

  if (!data) {
    console.error('数据格式错误或缺少必要字段');
    return res; // 保持原始数据结构不变
  }

  // 抽取一个通用的映射函数
  const mapCityList = (list) =>
    list.map((item) => ({
      ...item,
      cityId: item.id,
      name: item.cityName,
      pinyin: item.pinyin,
      first: item.aleph,
    }));
  return {
    ...data,
    city: data.cityId,
    cityList: mapCityList(data.cityList) || data.cityList,
    historyCities: mapCityList(data.historyCities) || data.historyCities,
    hotCities: mapCityList(data.hotCities) || data.hotCities,
  };
}
